import {LANGUAGE} from '@/common/utils/constants';

export const PROJECT_FORMS_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		submissionLanguageStepTitle: "New client success story",
		submissionLanguageStepSubTitle: "Please choose the language in which you want to submit your client success story",
		ifFirstTime: 'If this is your first time creating a client story, click to watch ',
		ourGuide: "our how-to video.",
		clientName: "Client name",
		clientNamePlaceholder: "Example: Megasoft Inc.",
		clientLogo: "Client logo",
		clientLogoHint: "Logo should be bigger than 300x300px with square (1:1) ratio or wider, but no wider than 3:1.",
		uploadFile: "Upload",
		confidentiality: "Client’s confidentiality",
		clientRelationship: "Client relationship",
		newBusiness: "New Business",
		clientLocationCovered: "Client`s locations covered",
		clientLocationCoveredPlaceholder: "Select one or more countries",
		startDate: "Start date",
		endDate: "End date",
		ongoingProject: "Ongoing project",
		clientContenxt: "Client context",
		clientContenxtPlaceholder: "Please provide background information on the client project environment and clearly outline the challenges of the client, its needs and requirements related to the project.",
		akkodisChallenges: "Akkodis challenges",
		akkodisChallengesPlaceholder: "Please list the obstacles (if any) the project encountered, and the way your team addressed them.",
		solution: "Solution",
		solutionPlaceholder: "Please focus on Akkodis’ approach to the client’s challenges, the specific actions the Akkodis team accomplished or was responsible for, and the services delivered.",
		fte: "FTEs",
		projectRevenue: "Project revenue",
		tools: "Tools & Systems",
		toolsPlaceholder: "Select one or more tools & systems",
		certification: "Certifications",
		certificationPlaceholder: "Select one or more certifications",
		deliveryLocations: "Project delivery locations",
		deliveryLocationsPlaceholder: "Select one or more countries",
		clientResults: "Client results",
		clientResultsPlaceholder: "Please focus on how Akkodis’ solution or service benefited the client. Please provide as many quantitative and qualitative inputs as possible to showcase the work delivered.",
		akkodisResults: "Akkodis results",
		akkodisResultsPlaceholder: "Focus on the value the project brought to our organization and the lessons learned for our teams.",
		testimonial: "Testimonial",
		testimonialName: "Name",
		testimonialRole: "Job role",
		testimonialQuate: "Quote",
		testimonialNamePlaceholder: "Example: John Silverman",
		testimonialRolePlaceholder: "Example: Senior Director",
		testimonialQuatePlaceholder: "Please add a quote from the client's representative, if available, to demonstrate the client's appreciation of our work.",
		addTestimonial: "Add testimonial",
		serviceLines: "Tipo de Negocio",
		businessLines: "Tech practices",
		deliveryManagerName: "Delivery manager name",
		deliveryManagerNamePlaceholder: "Example: John Silverman",
		deliveryManagerEmail: "Delivery manager email",
		deliveryManagerEmailPlaceholder: "Example: john.silverman@mail.com",
		businessManagerName: "Business manager name",
		businessManagerEmail: "Business manager email",
		linkPlaceholder: "Press enter to add 1 or more links",
		optional: "(optional)",
		CoverImage: "Cover image",
		CoverImageHint: "The image should be bigger than 300x300px with square (1:1) ratio or wider, but no wider than 3:1.",
		projectGallery: "Project gallery",
		projectGalleryHint: "The images should be bigger than 300x300px with square (1:1) ratio or wider, but no wider than 3:1.",
		projectGalleryPlaceholder: "Drag and drop or click here to <br> upload up to 5 images",
		steps_form_leave_btn: "Save",
		preview: "Preview",
		projectTitle: "Reference title",
		projectTitlePlaceholder: "Example: Megasoft Inc.",
		aboutTheclient: "About the client",
		aboutTheclientPlaceholder: "Please provide background information on the client project environment and clearly outline the challenges of the client, its needs and requirements related to the project.",
		industry: "Project industry",
		industryPlaceholder: "Search for one or more industries",
		validationSubTitle: "In order to validate the translation of the project, please approve or update all sections",
		show: "Show",
		delete: "Delete",
		submit: "Submit",
		edit: "Edit",
		previewMod: "Preview mode",
		successfullySubmitted: "Your project has been successfully submitted",
		approve: "Approve",
		approved: "Approved",
		editSection: "Edit section",
		cancel: "Cancel",
		update: "Update",
		updated: "Updated",
		validate: "Validate",
		linkKeyword: "Link keyword",
		linkKeywordPlaysholder: "Link’s short description",
		linkURL: "URL for redirect",
		addLink: "Add link",
		link: "Link",
		showClientNameAndLogoInternally: "Internal use only. Select if the client’s name and logo may be used internally but must not be shared externally. Project page and download forms will include an internal-use disclaimer.",
		showClientNameAndLogoExternally: "External use permitted. Select if the client’s name and logo are approved for both internal and external use.",
		hideClientNameAndLogo: "Anonymous client. Select if the client’s name and logo must remain confidential and hidden from all content and exports.",
		startReview: "Start review",
		finishReview: "Finish review",
		publish: "Publish",
		draft: "Draft",
		newSubmission: "New submission",
		assigned: "Assigned",
		underReview: "Under review",
		contentManagerValidation: "Content Manager Validation",
		referenceOwnerApproval: "Reference Owner Approval",
		finalReview: "Final Review",
		readyToPublish: "Ready to publish",
		published: "Published",
	},
	[LANGUAGE.it.short]: {
		submissionLanguageStepTitle: "Nuova storia di successo del cliente",
		submissionLanguageStepSubTitle: "Scegli la lingua in cui vuoi inviare la storia di successo del tuo cliente",
		ifFirstTime: 'Se questa è la prima volta che crei una storia di un cliente, fai clic per guardare ',
		ourGuide: "il nostro video su come",
		clientName: "Nome del cliente",
		clientNamePlaceholder: "Esempio: Megasoft Inc.",
		clientLogo: "Logo client",
		clientLogoHint: "Il logo deve essere più grande di 300x300px e con rapporto quadrato (1:1) o più largo, ma non più largo di 3:1.",
		uploadFile: "Caricamento",
		confidentiality: "Riservatezza del cliente",
		clientRelationship: "Relazione cliente",
		newBusiness: "Nuovo business",
		clientLocationCovered: "Posizioni del cliente coperte",
		clientLocationCoveredPlaceholder: "Seleziona uno o più paesi",
		startDate: "Data d'inizio",
		endDate: "Data di fine",
		ongoingProject: "Progetto in corso",
		clientContenxt: "Contesto del cliente",
		clientContenxtPlaceholder: "Si prega di fornire informazioni di base sull'ambiente del progetto del cliente e delineare chiaramente le sfide del cliente, le sue esigenze e i requisiti relativi al progetto.",
		akkodisChallenges: "Akkodis sfide",
		akkodisChallengesPlaceholder: "Elenca gli ostacoli (se presenti) il progetto riscontrato e il modo in cui il tuo team li ha affrontati.",
		solution: "Soluzione",
		solutionPlaceholder: "Si prega di concentrarsi sull'approccio di Akkodis alle sfide del cliente, sulle azioni specifiche che il team di Akkodis ha realizzato o è stato responsabile e i servizi forniti.",
		fte: "Fte",
		projectRevenue: "Entrate del progetto",
		tools: "Strumenti e sistemi",
		toolsPlaceholder: "Seleziona uno o più strumenti e sistemi",
		certification: "Certificazioni",
		certificationPlaceholder: "Seleziona una o più certificazioni",
		deliveryLocations: "Posizioni di consegna del progetto",
		deliveryLocationsPlaceholder: "Seleziona uno o più paesi",
		clientResults: "Risultati del cliente",
		clientResultsPlaceholder: "Si prega di concentrarsi su come la soluzione o il servizio di Akkodis ha beneficiato del cliente. Si prega di fornire il maggior numero possibile di input quantitativi e qualitativi per mostrare il lavoro offerto.",
		akkodisResults: "Risultati di Akkodis",
		akkodisResultsPlaceholder: "Concentrati sul valore che il progetto ha portato alla nostra organizzazione e sulle lezioni apprese per i nostri team.",
		testimonial: "Testimonial",
		testimonialName: "Nome",
		testimonialRole: "Ruolo",
		testimonialQuate: "Citazione",
		testimonialNamePlaceholder: "Esempio: John Silverman",
		testimonialRolePlaceholder: "Esempio: direttore senior",
		testimonialQuatePlaceholder: "Si prega di aggiungere un preventivo dal rappresentante del cliente, se disponibile, per dimostrare l'apprezzamento del cliente per il nostro lavoro.",
		addTestimonial: "Aggiungi testimonial",
		serviceLines: "Tipologia di attività",
		businessLines: "Pratiche tecnologiche",
		deliveryManagerName: "Nome responsabile della consegna",
		deliveryManagerNamePlaceholder: "Esempio: John Silverman",
		deliveryManagerEmail: "E -mail di consegna",
		deliveryManagerEmailPlaceholder: "Esempio: John.silverman@mail.com",
		businessManagerName: "Nome gestore aziendale",
		businessManagerEmail: "Email di Business Manager",
		linkPlaceholder: "Premere Invio per aggiungere 1 o più collegamenti",
		optional: "(opzionale)",
		CoverImage: "Immagine di copertina",
		CoverImageHint: "L'immagine deve essere più grande di 300x300px e con rapporto quadrato (1:1) o più largo, ma non più largo di 3:1.",
		projectGallery: "Galleria del progetto",
		projectGalleryHint: "Le immagini devono essere più grandi di 300x300px e con rapporto quadrato (1:1) o più largo, ma non più largo di 3:1.",
		projectGalleryPlaceholder: "Trascina e lascia cadere o fai clic qui per <br> Carica fino a 5 immagini",
		steps_form_leave_btn: "Salva",
		preview: "Anteprima",
		projectTitle: "Titolo di riferimento",
		projectTitlePlaceholder: "Esempio: Megasoft Inc.",
		aboutTheclient: "Informazioni sul cliente",
		aboutTheclientPlaceholder: "Si prega di fornire informazioni di base sull'ambiente del progetto del cliente e delineare chiaramente le sfide del cliente, le sue esigenze e i requisiti relativi al progetto.",
		industry: "Industria del progetto",
		industryPlaceholder: "Cerca una o più industrie",
		validationSubTitle: "Al fine di convalidare la traduzione del progetto, si prega di approvare o aggiornare tutte le sezioni",
		show: "Mostrare",
		delete: "Elimina",
		submit: "Invia",
		edit: "Modificare",
		previewMod: "Modalità anteprima",
		successfullySubmitted: "Il tuo progetto è stato inviato con successo",
		approve: "Approvare",
		approved: "Approvato",
		editSection: "Sezione di modifica",
		cancel: "Annulla",
		update: "Aggiornare",
		updated: "Aggiornato",
		validate: "Convalidare",
		linkKeyword: "Parola chiave di collegamento",
		linkKeywordPlaysholder: "Breve descrizione del collegamento",
		linkURL: "URL per il reindirizzamento",
		addLink: "Aggiungi collegamento",
		link: "Collegamento",
		showClientNameAndLogoInternally: "Mostra il nome e il logo del cliente internamente",
		showClientNameAndLogoExternally: "Mostra il nome e il logo del cliente esternamente",
		hideClientNameAndLogo: "Nascondi il nome e il logo del cliente internamente ed esternamente",
		startReview: "Inizia la revisione",
		finishReview: "Termina la revisione",
		publish: "Pubblicare",
		draft: "Bozza",
		newSubmission: "Nuova presentazione",
		assigned: "Assegnato",
		underReview: "In revisione",
		contentManagerValidation: "Convalida del gestore dei contenuti",
		referenceOwnerApproval: "Approvazione del proprietario di riferimento",
		finalReview: "Revisione finale",
		readyToPublish: "Pronto per la pubblicazione",
		published: "Pubblicato"
	},
	[LANGUAGE.de.short]: {
		submissionLanguageStepTitle: "Neue Kundenerfolgsgeschichte",
		submissionLanguageStepSubTitle: "Bitte wählen Sie die Sprache, in der Sie Ihre Kundenerfolgsgeschichte einreichen möchten",
		ifFirstTime: 'Wenn Sie zum ersten Mal eine Kundenstory erstellen, klicken Sie hier, um sie anzusehen ',
		ourGuide: "unser How-to-Video.",
		clientName: "Kundenname",
		clientNamePlaceholder: "Beispiel: Megasoft Inc.",
		clientLogo: "Client -Logo",
		clientLogoHint: "Das Logo sollte größer als 300x300px und mit quadratischem (1:1) oder breiterem Verhältnis sein, aber nicht breiter als 3:1.",
		uploadFile: "Hochladen",
		confidentiality: "Vertraulichkeit des Kunden",
		clientRelationship: "Kundenbeziehung",
		newBusiness: "Neues Geschäft",
		clientLocationCovered: "Die Standorte des Kunden abgedeckt",
		clientLocationCoveredPlaceholder: "Wählen Sie ein oder mehrere Länder aus",
		startDate: "Startdatum",
		endDate: "Endtermin",
		ongoingProject: "Laufendes Projekt",
		clientContenxt: "Client -Kontext",
		clientContenxtPlaceholder: "Bitte geben Sie Hintergrundinformationen zur Kundenprojektumgebung an und skizzieren Sie die Herausforderungen des Kunden, seine Bedürfnisse und Anforderungen im Zusammenhang mit dem Projekt klar.",
		akkodisChallenges: "Akkodis fordert sich heraus",
		akkodisChallengesPlaceholder: "Bitte listen Sie die Hindernisse (falls vorhanden) auf, das das Projekt auftritt, und die Art und Weise, wie Ihr Team sie angesprochen hat.",
		solution: "Lösung",
		solutionPlaceholder: "Bitte konzentrieren Sie sich auf den Ansatz von Akkodis bei den Herausforderungen des Kunden, die spezifischen Maßnahmen des Akkodis -Teams, für die das Akkodis -Team durchgeführt wurde oder für die die erbrachten Dienste verantwortlich waren.",
		fte: "Ftes",
		projectRevenue: "Projekteinnahmen",
		tools: "Tools & Systeme",
		toolsPlaceholder: "Wählen Sie ein oder mehrere Tools und Systeme aus",
		certification: "Zertifizierungen",
		certificationPlaceholder: "Wählen Sie eine oder mehrere Zertifizierungen aus",
		deliveryLocations: "Projektlieferungsorte",
		deliveryLocationsPlaceholder: "Wählen Sie ein oder mehrere Länder aus",
		clientResults: "Kundenergebnisse",
		clientResultsPlaceholder: "Bitte konzentrieren Sie sich darauf, wie die Lösung oder den Dienst von Akkodis dem Kunden zugute kam. Bitte geben Sie so viele quantitative und qualitative Eingaben wie möglich an, um die gelieferten Arbeiten zu präsentieren.",
		akkodisResults: "Akkodis Ergebnisse",
		akkodisResultsPlaceholder: "Konzentrieren Sie sich auf den Wert, den das Projekt für unsere Organisation und die für unsere Teams gezogenen Lektionen gewonnen hat.",
		testimonial: "Zeugnis",
		testimonialName: "Name",
		testimonialRole: "Stellenbeschreibung",
		testimonialQuate: "Zitieren",
		testimonialNamePlaceholder: "Beispiel: John Silverman",
		testimonialRolePlaceholder: "Beispiel: Senior Director",
		testimonialQuatePlaceholder: "Bitte fügen Sie ein Angebot vom Vertreter des Kunden hinzu, falls verfügbar, um die Wertschätzung unserer Arbeit durch den Kunden zu demonstrieren.",
		addTestimonial: "Zeugnis hinzufügen",
		serviceLines: "Geschäftsart",
		businessLines: "Technische Praktiken",
		deliveryManagerName: "Liefermanager Name",
		deliveryManagerNamePlaceholder: "Beispiel: John Silverman",
		deliveryManagerEmail: "Liefermanager -E -Mail",
		deliveryManagerEmailPlaceholder: "Beispiel: John.silverman@mail.com \"",
		businessManagerName: "Business Manager Name",
		businessManagerEmail: "Business Manager -E -Mail",
		linkPlaceholder: "Drücken Sie die Eingabetaste, um 1 oder mehr Links hinzuzufügen",
		optional: "(Optional)",
		CoverImage: "Titelbild",
		CoverImageHint: "Das Bild sollte größer als 300x300px und mit quadratischem (1:1) oder breiterem Verhältnis sein, aber nicht breiter als 3:1.",
		projectGallery: "Projektgalerie",
		projectGalleryHint: "Die Bilder sollten größer als 300x300px und mit quadratischem (1: 1) oder breiterem Verhältnis sein, aber nicht breiter als 3:1.",
		projectGalleryPlaceholder: "Ziehen und fallen lassen oder hier klicken, um bis zu 5 Bilder hochzuladen",
		steps_form_leave_btn: "Speichern",
		preview: "Vorschau",
		projectTitle: "Referenztitel",
		projectTitlePlaceholder: "Beispiel: Megasoft Inc.",
		aboutTheclient: "Über den Kunden",
		aboutTheclientPlaceholder: "Bitte geben Sie Hintergrundinformationen zur Kundenprojektumgebung an und skizzieren Sie die Herausforderungen des Kunden, seine Bedürfnisse und Anforderungen im Zusammenhang mit dem Projekt klar.",
		industry: "Projektbranche",
		industryPlaceholder: "Suche nach einer oder mehreren Branchen",
		validationSubTitle: "Um die Übersetzung des Projekts zu validieren, genehmigen oder aktualisieren Sie alle Abschnitte",
		show: "Zeigen",
		delete: "Löschen",
		submit: "Einreichen",
		edit: "Bearbeiten",
		previewMod: "Vorschau Modus",
		successfullySubmitted: "Ihr Projekt wurde erfolgreich eingereicht",
		approve: "Genehmigen",
		approved: "Genehmigt",
		editSection: "Abschnitt bearbeiten",
		cancel: "Stornieren",
		update: "Aktualisieren",
		updated: "Aktualisiert",
		validate: "Bestätigen",
		linkKeyword: "Link-Schlüsselwort",
		linkKeywordPlaysholder: "Kurze Beschreibung des Links",
		linkURL: "URL für die Weiterleitung",
		addLink: "Link hinzufügen",
		link: "Verknüpfung",
		showClientNameAndLogoInternally: "Zeigen Sie den Namen und das Logo des Kunden intern an",
		showClientNameAndLogoExternally: "Zeigen Sie den Namen und das Logo des Kunden extern an",
		hideClientNameAndLogo: "Verstecken Sie den Namen und das Logo des Kunden intern und extern",
		startReview: "Starten Sie die Überprüfung",
		finishReview: "Überprüfung abschließen",
		publish: "Veröffentlichen",
		draft: "Entwurf",
		newSubmission: "Neue Einreichung",
		assigned: "Zugewiesen",
		underReview: "In Überprüfung",
		contentManagerValidation: "Content Manager-Validierung",
		referenceOwnerApproval: "Genehmigung des Referenzeigentümers",
		finalReview: "Endgültige Überprüfung",
		readyToPublish: "Bereit zum Veröffentlichen",
		published: "Veröffentlicht"

	},
	[LANGUAGE.fr.short]: {
		submissionLanguageStepTitle: "Nouveau d'histoire de réussite du client",
		submissionLanguageStepSubTitle: "Veuillez choisir la langue dans laquelle vous souhaitez soumettre votre réussite",
		ifFirstTime: "Si c'est la première fois que vous créez une histoire de client, cliquez pour regarder ",
		ourGuide: "notre vidéo didactique.",
		clientName: "Nom du client",
		clientNamePlaceholder: "Exemple: Megasoft Inc.",
		clientLogo: "Logo client",
		clientLogoHint: "Le logo doit être plus grand que 300x300px et avec un rapport carré (1:1) ou plus large, mais pas plus large que 3:1.",
		uploadFile: "Télécharger",
		confidentiality: "Confidentialité du client",
		clientRelationship: "Relation client",
		newBusiness: "Nouvelle entreprise",
		clientLocationCovered: "Les emplacements du client couvert",
		clientLocationCoveredPlaceholder: "Sélectionnez un ou plusieurs pays",
		startDate: "Date de début",
		endDate: "Date de fin",
		ongoingProject: "Projet en cours",
		clientContenxt: "Contexte du client",
		clientContenxtPlaceholder: "Veuillez fournir des informations générales sur l'environnement du projet client et décrire clairement les défis du client, ses besoins et ses exigences liés au projet.",
		akkodisChallenges: "Défis Akkodis",
		akkodisChallengesPlaceholder: "Veuillez énumérer les obstacles (le cas échéant) que le projet a rencontrés et la façon dont votre équipe les a adressées.",
		solution: "La solution",
		solutionPlaceholder: "Veuillez vous concentrer sur l'approche d'Akkodis sur les défis du client, les actions spécifiques que l'équipe Akkodis a accomplies ou était responsable et les services fournis.",
		fte: "EFTE",
		projectRevenue: "Revenus du projet",
		tools: "Outils et systèmes",
		toolsPlaceholder: "Sélectionnez un ou plusieurs outils et systèmes",
		certification: "Certifications",
		certificationPlaceholder: "Sélectionnez une ou plusieurs certifications",
		deliveryLocations: "Emplacements de livraison de projet",
		deliveryLocationsPlaceholder: "Sélectionnez un ou plusieurs pays",
		clientResults: "Résultats du client",
		clientResultsPlaceholder: "Veuillez vous concentrer sur la façon dont la solution ou le service d'Akkodis a profité au client. Veuillez fournir autant d'entrées quantitatives et qualitatives que possible pour présenter les travaux livrés.",
		akkodisResults: "Résultats des akkodis",
		akkodisResultsPlaceholder: "Concentrez-vous sur la valeur que le projet a apporté à notre organisation et les leçons apprises pour nos équipes.",
		testimonial: "Témoignage",
		testimonialName: "Nom",
		testimonialRole: "Rôle de l'emploi",
		testimonialQuate: "Devis",
		testimonialNamePlaceholder: "Exemple: John Silverman",
		testimonialRolePlaceholder: "Exemple: directeur principal",
		testimonialQuatePlaceholder: "Veuillez ajouter un devis du représentant du client, si disponible, pour démontrer l'appréciation par le client de notre travail.",
		addTestimonial: "Ajouter le témoignage",
		serviceLines: "Type d'activité",
		businessLines: "Pratiques technologiques",
		deliveryManagerName: "Nom du gestionnaire de livraison",
		deliveryManagerNamePlaceholder: "Exemple: John Silverman",
		deliveryManagerEmail: "Email du gestionnaire de livraison",
		deliveryManagerEmailPlaceholder: "Exemple: John.silverman@mail.com",
		businessManagerName: "Nom du chef d'entreprise",
		businessManagerEmail: "Courriel de gestionnaire d'entreprise",
		linkPlaceholder: "Appuyez sur Entrée pour ajouter 1 ou plusieurs liens",
		optional: "(optionnel)",
		CoverImage: "Image de couverture",
		CoverImageHint: "L'image doit être plus grande que 300x300px et avec un rapport carré (1:1) ou plus large, mais pas plus large que 3:1.",
		projectGallery: "Galerie de projets",
		projectGalleryHint: "Les images doivent être plus grandes que 300x300px et avec un rapport carré (1: 1) ou plus large, mais pas plus large que 3:1.",
		projectGalleryPlaceholder: "Faites glisser et déposez ou cliquez ici pour <br> Télécharger jusqu'à 5 images",
		steps_form_leave_btn: "enregistrer",
		preview: "Aperçu",
		projectTitle: "Titre de référence",
		projectTitlePlaceholder: "Exemple: Megasoft Inc.",
		aboutTheclient: "À propos du client",
		aboutTheclientPlaceholder: "Veuillez fournir des informations générales sur l'environnement du projet client et décrire clairement les défis du client, ses besoins et ses exigences liés au projet.",
		industry: "Industrie du projet",
		industryPlaceholder: "Recherchez une ou plusieurs industries",
		validationSubTitle: "Afin de valider la traduction du projet, veuillez approuver ou mettre à jour toutes les sections",
		show: "Spectacle",
		delete: "Effacer",
		submit: "Soumettre",
		edit: "Éditer",
		previewMod: "Mode d'aperçu",
		successfullySubmitted: "Votre projet a été soumis avec succès",
		approve: "Approuver",
		approved: "A approuvé",
		editSection: "Section de modification",
		cancel: "Annuler",
		update: "Mise à jour",
		updated: "Mis à jour",
		validate: "Valider",
		linkKeyword: "Mot-clé du lien",
		linkKeywordPlaysholder: "Courte description du lien",
		linkURL: "URL de redirection",
		addLink: "Ajouter un lien",
		link: "Lien",
		showClientNameAndLogoInternally: "Afficher le nom et le logo du client en interne",
		showClientNameAndLogoExternally: "Afficher le nom et le logo du client à l'extérieur",
		hideClientNameAndLogo: "Masquer le nom et le logo du client en interne et en externe",
		startReview: "Démarrer la revue",
		finishReview: "Terminer la revue",
		publish: "Publier",
		draft: "Brouillon",
		newSubmission: "Nouvelle soumission",
		assigned: "Assigné",
		underReview: "En revue",
		contentManagerValidation: "Validation du gestionnaire de contenu",
		referenceOwnerApproval: "Approbation du propriétaire de référence",
		finalReview: "Révision finale",
		readyToPublish: "Prêt à publier",
		published: "Publié"
	},
	[LANGUAGE.ja.short]: {
		submissionLanguageStepTitle: "新しいクライアントのサクセスストーリー",
		submissionLanguageStepSubTitle: "クライアントのサクセスストーリーを提出したい言語を選択してください",
		ifFirstTime: 'これが初めてクライアントストーリーを作成する場合は、クリックして視聴してください ',
		ourGuide: "当社のハウツー動画。",
		clientName: "クライアント名",
		clientNamePlaceholder: "例：Megasoft Inc.",
		clientLogo: "クライアントロゴ",
		clientLogoHint: "ロゴは300x300pxより大きく、正方形（1：1）またはより広い比率である必要がありますが、3：1より広くはありません。",
		uploadFile: "アップロード",
		confidentiality: "クライアントの守秘義務",
		clientRelationship: "クライアント関係",
		newBusiness: "新しいビジネス",
		clientLocationCovered: "カバーされているクライアントの場所",
		clientLocationCoveredPlaceholder: "1つ以上の国を選択します",
		startDate: "開始日",
		endDate: "終了日",
		ongoingProject: "進行中のプロジェクト",
		clientContenxt: "クライアントコンテキスト",
		clientContenxtPlaceholder: "クライアントプロジェクト環境に関する背景情報を提供し、クライアントの課題、プロジェクトに関連するそのニーズと要件の概要を明確に概説してください。",
		akkodisChallenges: "Akkodisの挑戦",
		akkodisChallengesPlaceholder: "遭遇したプロジェクト（もしあれば）と、チームがそれらに対処する方法をリストしてください。",
		solution: "解決",
		solutionPlaceholder: "クライアントの課題に対するAkkodisのアプローチ、Akkodisチームが達成または責任を負った特定のアクション、およびサービスが提供したことに焦点を当ててください。",
		fte: "ftes",
		projectRevenue: "プロジェクト収益",
		tools: "ツールとシステム",
		toolsPlaceholder: "1つ以上のツールとシステムを選択します",
		certification: "認定",
		certificationPlaceholder: "1つ以上の認定を選択します",
		deliveryLocations: "プロジェクト配信の場所",
		deliveryLocationsPlaceholder: "1つ以上の国を選択します",
		clientResults: "クライアントの結果",
		clientResultsPlaceholder: "Akkodisのソリューションまたはサービスがクライアントにどのように利益をもたらしたかに焦点を当ててください。提供された作業を紹介するために、できるだけ多くの定量的および定性的入力を提供してください。",
		akkodisResults: "Akkodisの結果",
		akkodisResultsPlaceholder: "プロジェクトが私たちの組織にもたらした価値と、チームのために学んだ教訓に焦点を当てます。",
		testimonial: "証言",
		testimonialName: "見積もり",
		testimonialRole: "仕事の役割",
		testimonialQuate: "引用",
		testimonialNamePlaceholder: "例：ジョン・シルバーマン",
		testimonialRolePlaceholder: "例：シニアディレクター",
		testimonialQuatePlaceholder: "クライアントの代表者からの見積もりを追加して、クライアントの仕事に対する評価を実証してください。",
		addTestimonial: "証言を追加します",
		serviceLines: "事業の種類",
		businessLines: "技術慣行",
		deliveryManagerName: "配達マネージャー名",
		deliveryManagerNamePlaceholder: "例：ジョン・シルバーマン",
		deliveryManagerEmail: "配達マネージャーのメール",
		deliveryManagerEmailPlaceholder: "例：john.silverman@mail.com",
		businessManagerName: "ビジネスマネージャー名",
		businessManagerEmail: "ビジネスマネージャーのメール",
		linkPlaceholder: "Enterを押して、1つ以上のリンクを追加します",
		optional: "（オプション）",
		CoverImage: "表紙画像",
		CoverImageHint: "画像は300x300pxより大きく、正方形（1：1）またはより広い比率である必要がありますが、（3：1）より広くはありません",
		projectGallery: "プロジェクトギャラリー",
		projectGalleryHint: "画像は300x300pxより大きく、正方形（1：1）またはより広い比率である必要がありますが、（3：1）より広くはありません",
		projectGalleryPlaceholder: "ドラッグアンドドロップまたはここをクリックして<br>最大5つの画像をアップロードします",
		steps_form_leave_btn: "保存",
		preview: "プレビュー",
		projectTitle: "参照タイトル",
		projectTitlePlaceholder: "例：Megasoft Inc.",
		aboutTheclient: "クライアントについて",
		aboutTheclientPlaceholder: "クライアントプロジェクト環境に関する背景情報を提供し、クライアントの課題、プロジェクトに関連するそのニーズと要件の概要を明確に概説してください。",
		industry: "プロジェクト業界",
		industryPlaceholder: "1つ以上の産業を検索します",
		validationSubTitle: "*プロジェクトの翻訳を検証するために、すべてのセクションを承認または更新してください",
		show: "見せる",
		delete: "消去",
		submit: "送信",
		edit: "編集",
		previewMod: "プレビューモード",
		successfullySubmitted: "あなたのプロジェクトは正常に提出されました",
		approve: "承認",
		approved: "承認済み",
		editSection: "編集セクション",
		cancel: "キャンセル",
		update: "アップデート",
		updated: "更新しました",
		validate: "検証",
		linkKeyword: "リンクキーワード",
		linkKeywordPlaysholder: "リンクの簡単な説明",
		linkURL: "リダイレクト先のURL",
		addLink: "リンクを追加",
		link: "リンク",
		showClientNameAndLogoInternally: "クライアントの名前とロゴを内部で表示する",
		showClientNameAndLogoExternally: "クライアントの名前とロゴを外部で表示する",
		hideClientNameAndLogo: "クライアントの名前とロゴを内部および外部で非表示にする",
		startReview: "レビューを開始",
		finishReview: "レビューを終了",
		publish: "公開する",
		draft: "ドラフト",
		newSubmission: "新しい提出",
		assigned: "割り当てられた",
		underReview: "レビュー中",
		contentManagerValidation: "コンテンツマネージャーの検証",
		referenceOwnerApproval: "参照所有者の承認",
		finalReview: "最終レビュー",
		readyToPublish: "公開の準備ができました",
		published: "公開済み"
	},
	[LANGUAGE.es.short]: {
		submissionLanguageStepTitle: "Nueva historia de éxito del cliente",
		submissionLanguageStepSubTitle: "Seleccione el idioma en el que desea enviar la historia de éxito de su cliente",
		ifFirstTime: 'Si es la primera vez que crea una historia de cliente, haga clic para ver ',
		ourGuide: "nuestro video tutorial.",
		clientName: "Nombre del cliente",
		clientNamePlaceholder: "Ejemplo: Megasoft Inc.",
		clientLogo: "Logo del cliente",
		clientLogoHint: "El logotipo debe ser más grande que 300x300px y con una relación cuadrada (1:1) o más ancho, pero no más ancho que 3:1.",
		uploadFile: "Subir archivo",
		confidentiality: "Confidencialidad del cliente",
		clientRelationship: "Relación con el cliente",
		newBusiness: "Nuevo negocio",
		clientLocationCovered: "Ubicaciones del cliente cubiertas",
		clientLocationCoveredPlaceholder: "Seleccione uno o más países",
		startDate: "Fecha de inicio",
		endDate: "Fecha de finalización",
		ongoingProject: "Proyecto en curso",
		clientContenxt: "Contexto del cliente",
		clientContenxtPlaceholder: "Proporcione información básica sobre el entorno del proyecto del cliente y describa claramente los desafíos del cliente, sus necesidades y requisitos relacionados con el proyecto.",
		akkodisChallenges: "Desafíos de Akkodis",
		akkodisChallengesPlaceholder: "Enumere los obstáculos (si los hay) que encontró el proyecto y cómo su equipo los abordó.",
		solution: "Solución",
		solutionPlaceholder: "Concéntrese en el enfoque de Akkodis para los desafíos del cliente, las acciones específicas que realizó o fue responsable el equipo de Akkodis y los servicios proporcionados.",
		fte: "FTEs",
		projectRevenue: "Ingresos del proyecto",
		tools: "Herramientas y sistemas",
		toolsPlaceholder: "Seleccione una o más herramientas y sistemas",
		certification: "Certificaciones",
		certificationPlaceholder: "Seleccione una o más certificaciones",
		deliveryLocations: "Ubicaciones de entrega del proyecto",
		deliveryLocationsPlaceholder: "Seleccione uno o más países",
		clientResults: "Resultados del cliente",
		clientResultsPlaceholder: "Concéntrese en cómo la solución o el servicio de Akkodis benefició al cliente. Proporcione tantas entradas cuantitativas y cualitativas como sea posible para presentar el trabajo entregado.",
		akkodisResults: "Resultados de Akkodis",
		akkodisResultsPlaceholder: "Concéntrese en el valor que el proyecto ha aportado a nuestra organización y las lecciones aprendidas para nuestros equipos.",
		testimonial: "Testimonio",
		testimonialName: "Nombre",
		testimonialRole: "Rol del trabajo",
		testimonialQuate: "Cita",
		testimonialNamePlaceholder: "Ejemplo: John Silverman",
		testimonialRolePlaceholder: "Ejemplo: Director Senior",
		testimonialQuatePlaceholder: "Agregue una cita del representante del cliente, si está disponible, para demostrar el aprecio del cliente por nuestro trabajo.",
		addTestimonial: "Agregar testimonio",
		serviceLines: "Tipo de Negocio",
		businessLines: "Prácticas tecnológicas",
		deliveryManagerName: "Nombre del gerente de entrega",
		deliveryManagerNamePlaceholder: "Ejemplo: John Silverman",
		deliveryManagerEmail: "Correo electrónico del gerente de entrega",
		deliveryManagerEmailPlaceholder: "Ejemplo: john.silverman@mail.com",
		businessManagerName: "Nombre del gerente de negocios",
		businessManagerEmail: "Correo electrónico del gerente de negocios",
		linkPlaceholder: "Presione Enter para agregar 1 o más enlaces",
		optional: "(opcional)",
		CoverImage: "Imagen de portada",
		CoverImageHint: "La imagen debe ser más grande que 300x300px y con una relación cuadrada (1:1) o más ancha, pero no más ancha que 3:1.",
		projectGallery: "Galería del proyecto",
		projectGalleryHint: "Las imágenes deben ser más grandes que 300x300px y con una relación cuadrada (1:1) o más ancha, pero no más ancha que 3:1.",
		projectGalleryPlaceholder: "Arrastre y suelte o haga clic aquí para <br> Cargar hasta 5 imágenes",
		steps_form_leave_btn: "Guardar",
		preview: "Vista previa",
		projectTitle: "Título de referencia",
		projectTitlePlaceholder: "Ejemplo: Megasoft Inc.",
		aboutTheclient: "Acerca del cliente",
		aboutTheclientPlaceholder: "Proporcione información básica sobre el entorno del proyecto del cliente y describa claramente los desafíos del cliente, sus necesidades y requisitos relacionados con el proyecto.",
		industry: "Industria del proyecto",
		industryPlaceholder: "Busque una o más industrias",
		validationSubTitle: "Para validar la traducción del proyecto, apruebe o actualice todas las secciones",
		show: "Mostrar",
		delete: "Eliminar",
		submit: "Enviar",
		edit: "Editar",
		previewMod: "Modo de vista previa",
		successfullySubmitted: "Su proyecto se ha enviado con éxito",
		approve: "Aprobar",
		approved: "Aprobado",
		editSection: "Editar sección",
		cancel: "Cancelar",
		update: "Actualizar",
		updated: "Actualizado",
		validate: "Validar",
		linkKeyword: "Palabra clave del enlace",
		linkKeywordPlaysholder: "Descripción breve del enlace",
		linkURL: "URL de redirección",
		addLink: "Agregar enlace",
		link: "Enlace",
		showClientNameAndLogoInternally: "Mostrar el nombre y el logotipo del cliente internamente",
		showClientNameAndLogoExternally: "Mostrar el nombre y el logotipo del cliente externamente",
		hideClientNameAndLogo: "Ocultar el nombre y el logotipo del cliente internamente y externamente",
		startReview: "Iniciar revisión",
		finishReview: "Finalizar revisión",
		publish: "Publicar",
		draft: "Borrador",
		newSubmission: "Nueva presentación",
		assigned: "Asignado",
		underReview: "En revisión",
		contentManagerValidation: "Validación del administrador de contenido",
		referenceOwnerApproval: "Aprobación del propietario de referencia",
		finalReview: "Revisión final",
		readyToPublish: "Listo para publicar",
		published: "Publicado"
	},
}
